import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { FullScreenState } from '@workspace/ui/components/full-screen-state'
import { useState } from 'react'
import { InvestorLayout } from '../../../../components/investor-layout'
import { useInvestorContext } from '../../../../contexts/investor-guard'
import { CustomDiligenceDialog } from '../../../../features/deal-flow/components/custom-diligence-dialog'
import { useInvestorEvaluationRequestsQuery } from '../../../../hooks/api'

export const Route = createFileRoute('/app/investor/$id/evaluate/$startupId')({
  component: InvestorEvaluatePage,
})

function InvestorEvaluatePage() {
  const { startupId } = Route.useParams()
  const { investor } = useInvestorContext()
  const navigate = useNavigate()
  const requestsQuery = useInvestorEvaluationRequestsQuery(investor.id)
  const [open, setOpen] = useState(true)

  const startupName = requestsQuery.data?.data?.find((r) => r.startupId === startupId)?.startupName

  const goToFeed = () => navigate({ to: '/app/investor/$id/feed', params: { id: investor.id } })

  return (
    <InvestorLayout activeNav="">
      <FullScreenState loading title="Custom diligence" />
      <CustomDiligenceDialog
        investorId={investor.id}
        startupId={startupId}
        startupName={startupName}
        disabled={!investor.websiteUrl}
        open={open}
        onOpenChange={(next) => {
          setOpen(next)
          if (!next) goToFeed()
        }}
        onSuccess={goToFeed}
      />
    </InvestorLayout>
  )
}
